import React from "react";
import PropTypes from "prop-types";
import OptionPicker from "theme/components/organisms/Configurator/OptionPicker";
import Fieldset from "theme/components/atoms/Form/Fieldset";
import Stack from "theme/components/atoms/Layout/Stack";

const isDev = process.env.NODE_ENV === "development";

const ConfigurableOptions = ({ options, currentOptions, selectedOptions }) => {
  if (!options || options.length === 0) {
    return null;
  }

  if (currentOptions && isDev) {
    console.warn(
      "using `<ConfigurableOptions>` with `currentOptions` prop is deprecated. It will be removed in 3.0. Please use `selectedOptions` instead, by passing values consolidated by `useSelectedProductWithConfigurableOptions`. See https://developers.front-commerce.com/docs/appendices/migration-guides.html#deprecated-currentoptions-prop-of-configurableoptions for more details."
    );
  }

  return (
    <Fieldset>
      <Stack size="2">
        {options.map((option) => {
          let optionPickerProps;
          if (currentOptions) {
            const formattedOption = {
              label: option.label,
              id: option.attribute.id,
              values: option.values,
            };
            const currentOption = currentOptions.find(
              (currentOption) => currentOption.label === option.label
            );
            let selectedOption = null;
            if (currentOption) {
              selectedOption = option.values.find(
                (value) => value.label === currentOption.value
              );
            }
            optionPickerProps = {
              key: formattedOption.id,
              selectedOption: selectedOption ? selectedOption.value : null,
              option: formattedOption,
            };
          } else {
            optionPickerProps = {
              key: option.id,
              selectedOption: selectedOptions[option.id],
              option,
            };
          }

          return (
            <OptionPicker
              key={optionPickerProps.key}
              selectedOption={optionPickerProps.selectedOption}
              option={optionPickerProps.option}
            />
          );
        })}
      </Stack>
    </Fieldset>
  );
};

ConfigurableOptions.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.object,
  currentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired
  ),
};

export default ConfigurableOptions;
